// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media only screen and (min-width: 768px) {\n.proposal-token-history__filter-manager[data-v-2d852bd1] .ab-btn.success {\n    width: 80%;\n}\n}", ""]);
// Exports
module.exports = exports;
